import './Contact.css';
import Swal from 'sweetalert2';
import { useRef } from 'react';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_x6gb1jt', 'template_t5s1bes', form.current, {
        publicKey: 'w_SdFxnpj1wnZZvdM',
      })
      .then(
        () => {
          Swal.fire({
            title: "Skickats",
            text: "Meddelandet har skickats",
            icon: "Success"
        });
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };
  return (
    <div id='contact' className='contact_us'>
    <div className="contact-form">
      <div className="flow">
        <div className='flow_title'>Contact us</div>
      </div>
      <form form ref={form} onSubmit={sendEmail}>
        <div className="form-group">
          <label for="name">Name</label>
          <input type="text" name='name' required />
        </div>
        <div className="form-group">
          <label for="company">Email</label>
          <input type="email"  name='email' required />
        </div>
        <div className="form-group">
          <label for="phone">Message</label>
          <textarea type='text' name='message' required />
        </div>
        <br />
        <button type='submit'>Send</button>
      </form>
    </div>
    </div>
  )
}

export default Contact